import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useContext, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "./authContext/AuthContext";
import { setShop } from "./authContext/AuthActions";
import Home from "./components/Home"
import Login from "./components/Login"
import Leftbar from "./components/Leftbar";
import Invoice from "./components/Invoice";
import Reports from "./components/Reports";
import ListItems from "./components/ListItems";
import ListUsers from "./components/ListUsers"
import Navbar from './components/Navbar'
import LoginShop from "./components/LoginShop";
import Transfer from "./components/Transfer";
import EodStock from "./components/EodStock";
import OpeningStock from "./components/OpeningStock";
import POSPage from "./components/POSPage";
import AppSettings from "./components/AppSettings";

const App = () => {
  const { user, shop, dispatch } = useContext(AuthContext);

  useEffect(() => {
    const fetchSettings = async () => {
      if (user && shop && !shop.settings) {
        try {
          const res = await axios.get("/settings", {
            headers: { token: "Bearer " + user.token, shopkey: shop.shopkey }
          });
          const settings = Array.isArray(res.data) ? res.data : [];
          dispatch(setShop({ ...shop, settings }, user));
        } catch (err) {
          try {
            const fallbackRes = await axios.get(`/settings/find?shopKey=${shop.shopkey}`, {
              headers: { token: "Bearer " + user.token }
            });
            const settings = fallbackRes.data && fallbackRes.data.settings ? [fallbackRes.data] : [];
            dispatch(setShop({ ...shop, settings }, user));
          } catch (e) {
            console.log("Error fetching settings:", e);
            dispatch(setShop({ ...shop, settings: [] }, user));
          }
        }
      }
    };
    fetchSettings();
  }, [user, shop, dispatch]);

  return (
    <Router>
      <Navbar height="7vh"/>
      <Switch>
        <Route exact path="/">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : <Home user={user}/>}</Route>
        <Route path="/loginshop">{!user ? <Login /> : <LoginShop allowedShops={user.allowedShops}/>}</Route>
        <Route path="/home">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : <Home user={user}/>}</Route>
        <Route path="/login">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : <Redirect to="/" />}</Route>
        <Route path="/pos">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : <Leftbar/>}</Route>
        <Route path="/poskeyboard">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : <POSPage/>}</Route>
        <Route path="/invoice">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : <Invoice/>}</Route>
        <Route path="/reports">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : user.isAdmin ? <Reports user={user}/> : <Home user={user}/> }</Route>
        <Route path="/items">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : user.isAdmin ? <ListItems/> : <Home user={user}/> }</Route>
        <Route path="/users">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : user.isAdmin ? <ListUsers/> : <Home user={user}/> }</Route>
        <Route path="/transfer">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : <Transfer/>}</Route>
        <Route path="/eodstock">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : <EodStock/>}</Route>
        <Route path="/openingstock">{!user ? <Login /> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : user.isAdmin ? <OpeningStock/> : <Home user={user}/> }</Route>
        <Route path="/settings">{!user ? <Login /> : user.isAdmin ? <AppSettings/> : !shop ? <LoginShop allowedShops={user.allowedShops} /> : <Home user={user}/>}</Route>
      </Switch>
    </Router>
  );
};

export default App;
